import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from './interface';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(
    private http : HttpClient
  ) { }

  getDocuments(modelId, modelName){
    let params : HttpParams = new HttpParams().set("modelId", modelId).set("modelName", modelName);
    return this.http.get<response>(environment.url+"documents", {params: params});
  }

  saveDocument(postdata){
    return this.http.post<response>(environment.url + "documents", postdata, {
      reportProgress: true,
      observe: 'events'
    });
  }

  deleteDocument(id, tableName, password){
    let params : HttpParams = new HttpParams().set('id', id).set('tableName', tableName).set('password', password);
    return this.http.delete<response>(environment.url+"documents", {params : params });
  }

}
